/**
 * 録音経路の API リクエスト timeout (ms).
 *
 * timeout 無し (axios default) だと瞬断・network stall 後に chunk/finalize/upload が
 * 無限 hang し、 録音 UI が 'finalizing' で固着する. 録音経路の call にだけ per-request で
 * 上限を設け、 hang を確実に失敗判定へ倒して救済導線 (retry/DL) に繋ぐ.
 *
 * 注: 共有 client instance には既定 timeout を設定しない (auth/template/stats 等
 * 録音と無関係な endpoint の挙動を変えないため). 録音経路の call が個別に override する.
 */

/**
 * stream chunk POST の上限. chunk は ChunkSendQueue で直列送信 (in-flight 常に 1 本)
 * されるため、 1 POST の stall が後続すべてを止める (head-of-line blocking). backend の
 * Chirp stream は client からの音声途絶 ~10s で Google 側 ABORT するので、 最悪ケース
 * (timeout + backoff 300ms + retry timeout ≈ 6.3s) がその予算内に収まるよう 3s に詰める.
 * timeout しても音声は client キューに残っており、 retry 成功時はまとめ送りで即回収される
 * ため短縮によるデータ損失は無い.
 */
export const API_TIMEOUT_CHUNK_MS = 3_000

/**
 * finalize / 音声 upload (multipart) の上限. 音声 multipart は数 MB になりうるため長め.
 */
export const API_TIMEOUT_UPLOAD_MS = 120_000
